// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import HealthTag from '../../HealthTag'
import classNames from 'classnames'
import './index.less'
import { connect } from 'react-redux'
import { Spin, Col, Row, Space } from 'antd'
import locationPng from 'assets/images/location.png'
import { CameraActivityCircle } from 'components/camera-activity-circle'
import { OnlineHoursCell } from 'components/camera-details/OnlineHoursCell'

class CameraStatus extends React.Component {
  render () {
    const { camera={}, loading } = this.props
    return (
      <Spin spinning={loading}>
        <div className={classNames('camera-status', { loading })}>
          <div className='head'>
            <Row justify='space-between' align='middle'>
              <Col>
                <Space size={4}>
                  <div className='camera-id'>{camera.deviceID}</div>
                  <CameraActivityCircle status={camera.onlineStatus} />
                </Space>
              </Col>
              <Col>
                <HealthTag style={{ marginRight: '0px' }} className='health-status' status={camera.status} />
              </Col>
            </Row>
            <div className='gray-text text-loading-effect'>World Cam</div>
            <div className='location text-loading-effect'>
              <img src={locationPng} style={{ width: 13, height: 11, marginRight: 4 }} alt='icon' />
              {camera.road || 'Road name not found'}
            </div>
          </div>
          <div className='content'>
            <div className='title'>Today</div>
            <div className='items'>
              <div className='item'>
                <div className='value text-loading-effect'>
                  <OnlineHoursCell onlineMinutes={camera.onlinePeriod} />
                </div>
                <div className='gray-text'>Online Time</div>
              </div>
              <div className='item'>
                <div className='value text-loading-effect'>{camera.distanceCovered} km</div>
                <div className='gray-text'>Travel Distance</div>
              </div>
            </div>
            <div className='title'>Last 7 Days's Avg</div>
            <div className='items'>
              <div className='item'>
                <div className='value text-loading-effect'>
                  <OnlineHoursCell onlineMinutes={camera.onlinePeriodPerday} />
                </div>
                <div className='gray-text'>Online Time</div>
              </div>
              <div className='item'>
                <div className='value text-loading-effect'>{camera.distCoveredPerday} km</div>
                <div className='gray-text'>Travel Distance</div>
              </div>
              <div className='item'>
                <div className='value text-loading-effect'>{camera.uniqueDistPerday} km</div>
                <div className='gray-text'>Unique KM</div>
              </div>
            </div>
          </div>
        </div>
      </Spin>
    )
  }
}

export default connect(
  ({ loading, cameras }) => ({
    loading: loading.effects.cameras.fetchCameraDetails,
    cameraDetails: cameras.cameraDetails
  }),
  ({ cameras }) => ({
    fetchCameraDetails: cameras.fetchCameraDetails
  }),
  (propsFromState, propsFromDispatch, propsFromParent) => {
    const cameraDetails = propsFromState.cameraDetails
    const combined = { ...propsFromState, ...propsFromDispatch, ...propsFromParent }
    if (combined.camera) {
      combined.camera = { ...combined.camera, ...cameraDetails[combined.camera.deviceID] }
    }
    return combined
  }
)(CameraStatus)
